import axios from '../../../axios';

export const startStopQueues=async (queueStatus,worker_name)=>{
   
    var payload={
        value : queueStatus,
        worker_name: worker_name
    }
    try{
        let  {status } = await axios.post(`${window._env.REACT_APP_EMCONSOLE_API_URL}/v1/queue/queue_status`,payload);
        if(status==200){
            return status;
        }
        return status;
    }catch(e){
        console.log('errror in start/stop queue')
    }
}